import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosError } from "axios";

import { RootState } from "features/config/store";
import { DailyAttendanceTableData } from "features/ms6/core/domain/DailyAttendanceTableData.model";
import {
  DailyAttendanceTableDataResponse,
  DailyAttendanceTableDataRepository,
} from "features/ms6/data/ms6.repository";

export enum dailyAttendanceTableDataState {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: dailyAttendanceTableDataState;
  message: string;
  data: DailyAttendanceTableData | undefined;
}

const initialState: InitialState = {
  status: dailyAttendanceTableDataState.initial,
  message: "",
  data: undefined,
};

export const dailyAttendanceTableData = createAsyncThunk(
  "dailyAttendanceTableData",
  async (_, { rejectWithValue }) => {
    try {
      const response: DailyAttendanceTableDataResponse =
        await DailyAttendanceTableDataRepository();
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

/* Main Slice */
export const dailyAttendanceTableDataSlice = createSlice({
  name: "dailyAttendanceTableData",
  initialState,
  reducers: {
    resetdailyAttendanceTableData: (state) => {
      state.status = dailyAttendanceTableDataState.initial;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(dailyAttendanceTableData.pending, (state) => {
        state.status = dailyAttendanceTableDataState.inProgress;
      })
      .addCase(dailyAttendanceTableData.fulfilled, (state, action) => {
        if (action.payload) {
          const { message, data } = action.payload;
          state.status = dailyAttendanceTableDataState.success;
          state.message = message;
          state.data = data;
        }
      })
      .addCase(dailyAttendanceTableData.rejected, (state, action) => {
        state.status = dailyAttendanceTableDataState.fail;
        state.message = action.payload as string;
      });
  },
});

export const selectdailyAttendanceTableData = (state: RootState) =>
  state.dailyAttendanceTableData;
export const { resetdailyAttendanceTableData } =
  dailyAttendanceTableDataSlice.actions;
export default dailyAttendanceTableDataSlice.reducer;
